import React, { useState } from 'react';
import {
  FaLock,
  FaEye,
  FaEyeSlash,
  FaKey,
  FaSave,
  FaTimes,
  FaShieldAlt,
} from 'react-icons/fa';
import { useToastMessages } from '../../components/MessageToast/MessageToast';

const ChangePassword = ({
  passwordEdit,
  setPasswordEdit,
  handlePasswordSave,
}) => {
  const { showSuccess, showError, ToastContainer } = useToastMessages();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    try {
      await handlePasswordSave(e);
      showSuccess('Parola a fost schimbată cu succes!');
    } catch (error) {
      showError('A apărut o eroare la schimbarea parolei.');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-red-50 to-pink-50 p-8 rounded-2xl shadow-lg border border-red-100">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-red-500 text-white flex items-center justify-center rounded-xl shadow-lg">
            <FaLock className="text-xl" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              Securitate Cont
            </h2>
            <p className="text-gray-600">
              Schimbă parola pentru protecția contului
            </p>
          </div>
        </div>

        {passwordEdit ? (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-6">
              {/* Parola actuală */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaShieldAlt className="text-red-500" />
                  Parola Actuală
                </label>
                <div className="relative">
                  <input
                    type={showCurrentPassword ? 'text' : 'password'}
                    name="currentPassword"
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
                    placeholder="Introduceți parola actuală"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Parola nouă */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaKey className="text-red-500" />
                  Parola Nouă
                </label>
                <div className="relative">
                  <input
                    type={showNewPassword ? 'text' : 'password'}
                    name="newPassword"
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
                    placeholder="Introduceți parola nouă"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  Parola trebuie să conțină cel puțin 8 caractere, o literă mare
                  și o cifră
                </div>
              </div>

              {/* Confirmare parolă nouă */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaLock className="text-red-500" />
                  Confirmă Parola Nouă
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    name="confirmNewPassword"
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
                    placeholder="Confirmați parola nouă"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
              <div className="flex items-start gap-3">
                <FaShieldAlt className="text-yellow-500 mt-1" />
                <div className="text-sm text-yellow-800">
                  <p className="font-semibold mb-1">
                    Sfaturi pentru o parolă sigură:
                  </p>
                  <ul className="list-disc list-inside space-y-1 text-xs">
                    <li>Folosiți cel puțin 8 caractere</li>
                    <li>Includeți litere mari și mici</li>
                    <li>Adăugați cifre și caractere speciale</li>
                    <li>Evitați informații personale</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="submit"
                className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
              >
                <FaSave />
                Schimbă Parola
              </button>
              <button
                type="button"
                onClick={() => setPasswordEdit(false)}
                className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition-all"
              >
                <FaTimes />
                Anulează
              </button>
            </div>
          </form>
        ) : (
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
              <div className="flex items-center gap-4 mb-4">
                <FaLock className="text-red-500 text-2xl" />
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    Parola Contului
                  </h3>
                  <p className="text-sm text-gray-600">
                    Ultima modificare: Acum 3 săptămâni
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200">
                <FaShieldAlt className="text-green-500" />
                <span className="text-green-700 font-medium">
                  Parola este configurată și securizată
                </span>
              </div>
            </div>

            <button
              onClick={() => setPasswordEdit(true)}
              className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
            >
              <FaKey />
              Schimbă Parola
            </button>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default ChangePassword;
